import React, { useEffect, useState } from 'react';
import { AddRecord } from '../../../layouts/AddRecord';
import { InputField, SelectField, TextAreaField } from '../../../layouts/FormFields';
// import { InputField, SelectField, TextAreaField } from '../../layouts/FormFields';
import { Button, Form, Space, Upload, message, ColorPicker, Select, Switch, Divider } from 'antd'; //4.24.7

import getHeaders from '../../../utils/authHeaders';
import { app } from '../../../config';
import { UploadOutlined } from '@ant-design/icons';
import axios, { Axios } from 'axios';
import { useNavigate } from 'react-router-dom';
import TestComponent from '../../Products/TestComponent';

const AddBlogwithSelect = () => {
  const [loading, setLoading] = useState(false);
  const [addUserResp, setAddUserResp] = useState({});
  const [uploadVideo, setuploadVideo] = useState('');
  const [contentType, setContentType] = useState();
  const [imageupload, setimageupload] = useState(true);
  const [videoupload, setvideoupload] = useState(false);
  let [uploadUrl, setuploadUrl] = useState('');
  let [show, setShow] = useState(false);
  const [uploadObj, setUploadObj] = useState({});
  const [uploadedImg, setUploadedImg] = useState('');
  let [textEditorValue, settextEditorValue] = useState();
  const [isActive, setisActive] = useState(true);
let [editorarray,seteditorarray]=useState([]);
  const [imageuploading, setImageUploading] = useState(false);
  let navigate = useNavigate();
  const getBase64 = (img, callback) => {
    const reader = new FileReader();
    // reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  };
  const beforeUpload = (file) => {
    console.log(file);
    setuploadVideo('');
    if (file.type === 'image/jpeg' || file.type === 'image/png') {
      console.log('setting image type');
      setContentType('img');
    } else if (file.type === 'video/x-matroska' || file.type === 'video/mp4' || file.type === 'video/mkv') setContentType('video');
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'video/x-matroska' || file.type === 'video/mp4' || file.type === 'video/mkv';
    if (!isJpgOrPng) {
      message.error('You can only upload JPG/PNG file!');
    }
    console.log('file Checked');
    const isLt2M = file.size / 1024 / 1024 < file.type === 'video/mp4' ? 200 : 20;
    if (!isLt2M) {
      setLargeFile(true);
      message.error('Image must smaller than 20MB!');
    }
    console.log('message');
    return isJpgOrPng && isLt2M;
  };

  const handleuploadChange = (info) => {
    console.log(info);
    if (info.file.status === 'uploading') {
      setImageUploading(true);
      setLoading(true);
      return;
    }
    if (info.file.status === 'done') {
      // Get this url from response in real world.
      console.log(info.file);
      info.file ? console.log(info.file.response.result.data.Location) : console.log('Not found');
      info.file ? setUploadedImg(info.file.response.result.data.Location) : ' ';
      info.file ? setImageUploading(false) : '';
      getBase64(info.file.originFileObj, (url) => {
        setImageUploading(false);
        setLoading(false);
      });
    }
  };
  const submitData = () => {
    console.log('calling: ', uploadObj);

    if (Object.keys(uploadObj).length > 0) {
      uploadData(uploadObj);
    }
  };
  const uploadData = async (uploadObj) => {
    return console.log(uploadObj);
    // setLoading(true);
    // try {
    //   const res = await axios.post(`${app.URL}/api/v1/admin/blogs/create`, uploadObj, { headers: getHeaders() });
    //   console.log(res);

    //   if (res.data.result.success) {
    //     setAddUserResp(res.data.result);
    //     message.success(res.data.result.msg);
    //     setTimeout(() => {
    //       navigate('/blogs/view');
    //     }, 1000);
    //   } else if (!res.data.result.success) {
    //     message.warning(res.data.result.msg);
    //   }
    // } catch (err) {
    //   setLoading(false);
    //   setShow(false);

    //   console.log(err);
    //   if (err) console.log(err.response.data.message);
    //   else return;
    // }
  };
  const handleContentDisplay = (event) => {
    console.log(event);
    if (event == 'Image') {
      setimageupload(true);
      setvideoupload(false);
    } else {
      setvideoupload(true);
      setimageupload(false);
    }
    // setContentDis(event);
  };

  console.log(imageupload);
  console.log(videoupload);

  const onFinish = (values) => {
    console.log(values);

    setUploadObj({
      // contentDisplay: values.viewType ? values.viewType : null,
      contentDisplay: 'Image',
      title: values.Title ? values.Title : null,
      // description: values.description ? values.description : null,
      description: editorarray,
      imageUrl: imageupload ? uploadedImg : null,
      videoUrl: videoupload ? uploadedImg : null,
      isActive: isActive,

      //   isActive: values.isActive,
    });
    setShow(true);
    submitData();
  };
  console.log(uploadObj);
  const handleClose = () => setShow(false);

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };
  console.log(imageupload);
  console.log(videoupload);

  console.log(uploadedImg);
  console.log(imageuploading);
  console.log(typeof textEditorValue, textEditorValue);

  const nextValue=()=>{
console.log(textEditorValue);
   textEditorValue? seteditorarray((prev)=>[...prev,textEditorValue]):'';
  console.log(editorarray);

  }
  console.log(editorarray);

  return (
    <>
      <AddRecord
        pageTitle='Add Blog'
        loading={loading}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        initialValues={{
          remember: true,
          ['isActive']: true,
          ['viewType']: 'Image',
        }}
        inputs={[
          <div className='col-lg-8'>
            <div className='row'>
              <SelectField
                col='col-lg-6'
                name='viewType'
                ishidden={true}
                onChange={(e) => handleContentDisplay(e)}
                options={[
                  { value: 'Video', name: 'Video' },
                  { value: 'Image', name: 'Image' },
                ].map((item) => (
                  <Select.Option value={item.value}>{item.name}</Select.Option>
                ))}
                rules={[
                  {
                    required: true,
                    message: 'Select Content Display',
                  },
                ]}
                required={true}
                // label='Select Content Type'
              />
              ,
              <InputField
                col='col-md-6 col-12'
                name='Title'
                label='Blog Title'
                rules={[
                  {
                    required: true,
                    message: 'Enter title',
                  },
                ]}
                placeholder='Enter title'
                required={true}
                // maxLength={6}
                // onKeyPress={handleKeysPress}
              />
            </div>
          </div>,
        ]}
        extras={[
          <div className='col-lg-12 mb-4'>
            <h2 className='dynamic-field-head'>Store</h2>
            <Form.List name='stores'>
              {(fields, { add, remove }, { errors }) => (
                <>
                  {fields.map((field, index) => (
                    // <Space className='col-lg-12' key={field.key}>
                    <Form.Item required={false} key={field.key}>
                      <div className='row'>
                        <Form.Item
                          className='col-lg-9 '
                          {...field}
                          validateTrigger={['onChange', 'onBlur']}
                          // noStyle
                        >
                          <div className='col-md-12 col-12 mb-12'>
                            <TestComponent textvalue={settextEditorValue} initialText='sdFSFG' />
                          </div>
                        </Form.Item>
                        <Form.Item className='col-lg-3 mt-1'>
                          {fields.length > 0 && (
                            <div className='add-btn' style={{ textAlign: 'center', backgroundColor: '#F21D2F' }} onClick={() => remove(field.name)}>
                              Remove
                            </div>
                          )}
                        </Form.Item>
                      </div>
                    </Form.Item>
                    // </Space>
                  ))}

                  <div className='row px-2'>
                    <div
                      style={{ textAlign: 'center' }}
                      onClick={() => {
                        add();
                        nextValue();
                      }}
                      className='col-lg-3 add-btn'
                    >
                      Add Store
                    </div>
                    {/* <div
                      style={{ textAlign: 'center' }}
                      onClick={() => {
                        // add();
                        nextValue();
                      }}
                      className='col-lg-3 add-btn'
                    >
                      complete blog
                    </div> */}
                  </div>
                  <Form.ErrorList errors={errors} />
                </>
              )}
            </Form.List>
          </div>,
        ]}
        upload={imageupload}
        vdoupload={videoupload}
        // action={`${videoupload}? ${app.URL}/api/v1/general/product/videoUpload :${app.URL}/api/v1/general/user/imageupload `}
        action={`${videoupload ? `${app.URL}/api/v1/general/product/videoUpload` : `${app.URL}/api/v1/general/user/imageupload`}`}
        beforeUpload={beforeUpload}
        handleuploadChange={handleuploadChange}
        imageuploading={imageuploading}
        submitData={submitData}
        uploadedImg={uploadedImg}
        isRichTextEditor={false}
        switchBtn={true}
        setisActiv={setisActive}
        textEditorsValue={settextEditorValue}
      />
    </>
    //     <div>
    //  <AddRecord
    //         loading={loading}
    //         pageTitle='Add Blog'
    //         // addUserResp={addUserResp}
    //         onFinish={onFinish}
    //         onFinishFailed={onFinishFailed}
    //         // switchBtn={true}
    //         initialValues={{
    //           remember: true,
    //           ['isActive']: true,
    //         }}
    //         inputs={[
    //           <div className='col-lg-8'>
    //             <div className='row'>
    //               <SelectField
    //                 col='col-lg-6'
    //                 name='viewType'
    //                 onChange={(e) => handleContentDisplay(e)}
    //                 options={[
    //                   { value: 'Video', name: 'Video' },
    //                   { value: 'Image', name: 'Image' },
    //                 ].map((item) => (
    //                   <Select.Option value={item.value}>{item.name}</Select.Option>
    //                 ))}
    //                 rules={[
    //                   {
    //                     required: true,
    //                     message: 'Select Content Display',
    //                   },
    //                 ]}
    //                 required={true}
    //                 label='Show Description'
    //               />
    //             </div>
    //           </div>,
    //           <TextAreaField
    //             showCount={true}
    //             maxLength={1000}
    //             col='col-lg-8'
    //             name='description'
    //             rules={[
    //               {
    //                 required: true,
    //                 message: 'Enter Description',
    //               },
    //             ]}
    //             required={true}
    //             placeholder='Enter description'
    //             label='Description'
    //             rows={8}
    //           />,
    //           <div className='col-md-4 col-12 mb-lg-0 mb-2'>
    //             {videoupload || uploadVideo && <label>Video</label>}
    //             { videoupload ||  uploadVideo && (
    //               <video style={{ width: '100%', borderRadius: '5px', boxShadow: '3px 3px 10px #ccc' }} controls title='YouTube video player'>
    //                 <source src={uploadVideo} type='video/mp4 || video/mkv'></source>
    //               </video>
    //             )}
    //             <Form.Item colon={false} name='video' className='mt-2'>
    //               <Space
    //                 direction='vertical'
    //                 style={{
    //                   width: '100%',
    //                 }}
    //                 size='large'
    //               >
    //                 <Upload  listType='picture' maxCount={1} className='avatar-uploader' headers={getHeaders()} action={`${app.URL}/api/v1/general/product/videoUpload`} beforeUpload={beforeUpload} onChange={handleuploadChange}>
    //                   <Button icon={<UploadOutlined />} className={'upload-btn'} style={{ color: 'black' }}>
    //                     Upload Video
    //                   </Button>
    //                   {/* <div className='mt-2'>Note: Upload size for video is 50mb supported format for video are (mkv/mp4)</div> */}
    //                 </Upload>
    //               </Space>
    //             </Form.Item>
    //           </div>,
    //          ]}

    //       addMessage='Are you sure you want to add blog?'
    //        handleClose={handleClose}
    //        show={show}
    //         goBack={goBack}
    //         upload={true}
    //          action={`${app.URL}/api/v1/general/user/imageupload`}
    //          beforeUpload={beforeUpload}
    //          handleuploadChange={handleuploadChange}
    //     imageuploading={imageuploading}
    //     submitData={submitData}
    //      uploadedImg={uploadedImg}
    // />
    //     </div>
  );
};

export default AddBlogwithSelect;
